import React, { useEffect, useRef } from 'react';

interface VantaEffect {
  destroy: () => void;
}

declare global {
  interface Window {
    THREE: unknown;
    VANTA: {
      BIRDS: (opts: Record<string, unknown>) => VantaEffect;
    };
  }
}

const VantaBirdsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const effectRef = useRef<VantaEffect | null>(null);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) return;

    const init = () => {
      if (!wrapperRef.current || effectRef.current) return;
      if (!window.VANTA?.BIRDS) return;

      try {
        effectRef.current = window.VANTA.BIRDS({
          el: wrapperRef.current,
          THREE: window.THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200,
          minWidth: 200,
          scale: 1.0,
          scaleMobile: 1.0,
          birdSize: 1.0,
          separation: 56,
          quantity: 3,
          backgroundAlpha: 0,
          color1: 0xdb2777,
          color2: 0xf472b6,
        });
      } catch (e) {
        console.error('[Vanta] init failed:', e);
      }
    };

    const vanta = window.VANTA as typeof window.VANTA | undefined;
    if (vanta?.BIRDS) {
      init();
    } else {
      // Scripts still loading — wait for load event
      window.addEventListener('load', init, { once: true });
    }

    return () => {
      window.removeEventListener('load', init);
      effectRef.current?.destroy();
      effectRef.current = null;
    };
  }, []);

  return (
    <div ref={wrapperRef} className="vanta-birds-wrapper">
      {children}
    </div>
  );
};

export default VantaBirdsWrapper;
